<template>
  <modal :center="false" :show="visible" modalClasses="modal-xxl">
    <b-row class="sticky-top pt-2 bg-light mt--3 mb-2">
      <b-col sm="12" md="4">
        <b-button class="mb-2" block variant="secondary" @click="handleClose">
          Đóng (Esc)
        </b-button>
      </b-col>
      <b-col sm="12" md="4">
        <b-button block variant="info" @click="doPrint"> <i class="fa fa-print" aria-hidden="true"></i> In </b-button>
      </b-col>
      <b-col sm="12" md="4">
        <b-button :disabled="receipt.id != ''" block variant="success" @click="doSave">
          <i class="fa fa-save" aria-hidden="true"></i>
          {{ receipt.id != '' ? 'Đã lưu phiếu' : 'Lưu phiếu' }}
        </b-button>
      </b-col>
    </b-row>
    <block ref="bmdal" :nobody="true">
      <div id="print-nhap" class="print-box mt-3 mb-3" style="padding-top:25px; max-width: 1400px;">
        <div v-if="!mutiple">
          <div class="header text-center">
            <h3>CÔNG TY TNHH ĐAI MI VN</h3>
            <img
              src="https://daimi.vn/resource/images/logo.png"
              style="position: absolute; left: 0;top: 0;width: 100px;"
              srcset=""
            />
            <span style="margin-right: 10px;">ADD : 66/2 Đường LK 2-5, P.Bình Trị Đông, TP.HCM </span>
            <span>Tel: 028-66828806 Email: daimivn@gmail.com </span>
            <h4 style="font-size: 20px; font-weight: bold; margin-bottom: 0;" class="mt-3">PHIẾU NHẬP KHO</h4>
            <b-row align-h="center">
              <span style="margin-right:15px" v-if="receipt.dateCreated">
                Date : {{ $dateUnix(receipt.dateCreated) }}
              </span>
              <span style="margin-right:15px" v-else> Date : {{ $date(receipt.date) }} </span>
              -
              <span style="margin-left:15px">Mã phiếu : {{ receipt.code }}</span>
            </b-row>
            <br />
            <!-- <div >
              <span>Mã đơn hàng : <b v-if="receipt.order">{{receipt.order.code }}</b></span> - <span> Mã lệnh chế tạo : <b>{{ receipt.manufacture.code }}</b></span>
            </div> -->
          </div>
          <div class="info">
            <table class="prtable">
              <tr>
                <td class="text-center"></td>
              </tr>
            </table>
          </div>
          <div class="data">
            <table class="prtable prtable-bordered">
              <thead>
                <tr>
                  <th style="width:1px">LCT/Mã ĐH</th>
                  <th colspan="2" style="min-width:200px">Sản phẩm</th>
                  <th style="width:60px">Màu sắc</th>
                  <th style="width:60px">Mã màu 1</th>
                  <th style="width:60px">Mã màu 2</th>
                  <th style="width:1px;min-width:40px">Quy cách</th>
                  <th>Chiều dài</th>
                  <th>Số lượng</th>
                  <th>ĐVT</th>
                  <th style="width:60px">VT lưu kho</th>
                  <th>Ghi chú</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in productReceipts" :key="index">
                  <td>
                    <span style="white-space: nowrap;">{{ receipt.manufacture.code }} /</span><br />
                    <b v-if="receipt.order">{{ receipt.order.code }}</b>
                  </td>
                  <td v-if="!item.hiden" :rowspan="item.rowSpan" style="text-align: left;">
                    {{ item.product.name }}
                    <!-- <span v-if="item.productCustom !=''"><br/>{{ item.productCustom }}</span> -->
                    <span v-if="item.reason"><br />{{ item.reason.name }}</span>
                  </td>
                  <td v-if="!item.hiden" :rowspan="item.rowSpan">
                    {{ item.product.code }}
                  </td>
                  <td>
                    <div class="d-flex">
                      <span style="width: 50px;    text-align: left;">
                        {{ capitalize(item.colorText) }}
                      </span>
                    </div>
                  </td>
                  <td>
                    <span style="width: 50px;text-align: center;"> {{ item.colorCode1 }}</span>
                  </td>
                  <td>
                    <span style="width: 50px;text-align: center;"> {{ item.colorCode2 }}</span>
                  </td>
                  <td>{{ item.productSpecify.name }}mm</td>
                  <td>{{ item.length }} CM</td>
                  <td>{{ $formatNumber(item.quantity) }}</td>
                  <td>{{ item.unit }}</td>
                  <td>
                    <span v-html="item.position"></span>
                  </td>
                  <td>
                    <span v-html="item.note"></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <div class="footer">
            <table class="prtable">
              <tr>
                <td colspan="2">
                  <div v-html="receipt.note"></div>
                </td>
              </tr>
              <tr>
                <td class="text-center">Người nhận hàng</td>
                <td class="text-center">Người phụ trách</td>
                <td class="text-center">
                  Người lập phiếu
                </td>
              </tr>
              <tr>
                <td><br /><br /><br /></td>
              </tr>
            </table>
          </div>
        </div>
        <div v-if="mutiple">
          <div class="header text-center">
            <h3>CÔNG TY TNHH ĐAI MI VN</h3>
            <img
              src="https://daimi.vn/resource/images/logo.png"
              style="position: absolute; left: 0;top: 0;width: 100px;"
              srcset=""
            />
            <span style="margin-right: 10px;">ADD : 66/2 Đường LK 2-5, P.Bình Trị Đông, TP.HCM </span>
            <span>Tel: 028-66828806 Email: daimivn@gmail.com </span>
            <h4 style="font-size: 20px; font-weight: bold;" class="mt-3">PHIẾU NHẬP KHO</h4>
          </div>
          <div v-for="(mrecept, index) in mutiRecepts" :key="index">
            <div class="header text-center">
              <!-- <h3>CÔNG TY TNHH ĐAI MI VN</h3>
              ADD : 66/2 Đường LK 2-5, P.Bình Trị Đông, TP.HCM <br />
              Tel: 028-66828806 Email: daimivn@gmail.com <br />
              <hr /> -->

              <b-row align-h="center">
                <span style="margin-right:15px" v-if="mrecept.dateCreated">
                  Date : {{ $dateUnix(mrecept.dateCreated) }}
                </span>
                <span style="margin-right:15px" v-else> Date : {{ $date(mrecept.date) }} </span>
                -
                <span style="margin-left:15px">Mã phiếu : {{ mrecept.code }}</span>
              </b-row>
              <div>
                <!-- <span>Mã đơn hàng : <b v-if="mrecept.order">{{mrecept.order.code }}</b></span> - <span> Mã lệnh chế tạo : <b>{{ mrecept.manufacture.code }}</b></span> -->
              </div>
            </div>

            <div class="data">
              <table class="prtable prtable-bordered">
                <thead>
                  <tr>
                    <th style="width:60px">LCT/Mã ĐH</th>

                    <th colspan="2" style="min-width:200px">Sản phẩm</th>
                    <th style="width:60px">Màu sắc</th>
                    <th style="width:60px">Mã màu 1</th>
                    <th style="width:60px">Mã màu 2</th>
                    <th style="width:1px;min-width:40px">Quy cách</th>
                    <th>Chiều dài</th>
                    <th>Số lượng</th>
                    <th>ĐVT</th>
                    <th style="width:60px">VT lưu kho</th>
                    <th>Ghi chú</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in mrecept.productReceipts" :key="index">
                    <td>
                      <span style="white-space: nowrap;">{{ mrecept.manufacture.code }} /</span><br />
                      <b v-if="mrecept.order">{{ mrecept.order.code }}</b>
                    </td>

                    <td v-if="!item.hiden" :rowspan="item.rowSpan" style="text-align: left;">
                      {{ item.product.name }}
                      <!-- <span v-if="item.productCustom != ''"><br />{{ item.productCustom }}</span> -->
                      <span v-if="item.reason"><br />{{ item.reason.name }}</span>
                    </td>
                    <td v-if="!item.hiden" :rowspan="item.rowSpan">
                      {{ item.product.code }}
                    </td>
                    <td>
                      <div class="d-flex">
                        <span style="width: 50px;    text-align: left;">
                          {{ capitalize(item.colorText) }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <span style="width: 50px;text-align: center;"> {{ item.colorCode1 }}</span>
                    </td>
                    <td>
                      <span style="width: 50px;text-align: center;"> {{ item.colorCode2 }}</span>
                    </td>
                    <td>{{ item.productSpecify.name }}mm</td>
                    <td>{{ item.length }} CM</td>
                    <td>{{ $formatNumber(item.quantity) }}</td>
                    <td>{{ item.unit }}</td>
                    <td>
                      <span v-html="item.position"></span>
                    </td>
                    <td>
                      <span v-html="item.note"></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            <table class="prtable">
              <tr>
                <td colspan="2">
                  <div v-html="mrecept.note"></div>
                </td>
              </tr>
            </table>
          </div>
          <div class="footer">
            <table class="prtable">
              <tr>
                <td class="text-center">Người nhận hàng</td>
                <td class="text-center">Người phụ trách</td>
                <td class="text-center">
                  Người lập phiếu
                </td>
              </tr>
              <tr>
                <td><br /><br /><br /></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <event @doCancel="handleClose"></event>
    </block>
  </modal>
</template>
<script>
import { capitalize } from '@/utils/string';
export default {
  props: {},
  data() {
    return {
      visible: false,
      mutiple: false,
      mutiRecepts: [],
      receipt: {
        id: '',
        type: 'in',
        customer: {},
        order: {},
        manufacture: {}
      },
      manufacture: {},
      productReceipts: {}
    };
  },
  methods: {
    setData(receipt, productReceipts, manufacture) {
      this.mutiple = false;
      this.receipt = receipt;
      this.manufacture = manufacture;
      // productReceipts.sort((a, b) => {
      //   if (a.product.name < b.product.name) {
      //     return -1;
      //   }
      //   if (a.product.name > b.product.name) {
      //     return 1;
      //   }
      //   return 0;
      // });
      // productReceipts.sort((a, b) => {
      //   if (a.spec.name > b.spec.name) {
      //     return -1;
      //   }
      //   if (a.spec.name < b.spec.name) {
      //     return 1;
      //   }
      //   return 0;
      // });
      productReceipts.sort((a, b) => {
        if (a.product.name < b.product.name) {
          return -1;
        }
        if (a.product.name > b.product.name) {
          return 1;
        } else {
          if (Number(a.productSpecify.name) > Number(b.productSpecify.name)) {
            return 1;
          }
          if (Number(a.productSpecify.name) < Number(b.productSpecify.name)) {
            return -1;
          }
          return 0;
        }
      });

      for (let i = 0; i < productReceipts.length; i++) {
        let item = productReceipts[i];
        item.rowSpan = this.checkSameRow(productReceipts, i, (a, b) => {
          return a.productSpecify.name == b.productSpecify.name && a.product.code == b.product.code;
        });
      }
      console.log('xxxx', productReceipts);
      this.productReceipts = productReceipts;
    },
    setDataMuti(mutiRecepts) {
      this.mutiple = true;
      this.mutiRecepts = mutiRecepts;
    },
    checkSameRow(datas, index, compareX, count = 1) {
      let nextIndex = index + 1;
      if (nextIndex >= datas.length) return 1;
      let item = datas[index];
      let nextItem = datas[nextIndex];
      if (compareX(item, nextItem)) {
        count++;
        nextItem.hiden = true;
        return 1 + this.checkSameRow(datas, nextIndex, compareX, count);
      }
      return 1;
    },
    handleClose() {
      this.visible = false;
    },
    doPrint() {
      this.$print('print-nhap');
    },
    doSave() {
      this.$refs.bmdal.block();
      this.$emit('doSave', () => {
        this.receipt.id = true;
        this.$refs.bmdal.unBlock();
      });
    },
    capitalize(s) {
      return capitalize(s);
    }
  }
};
</script>
